import React from 'react';
import PropTypes from 'prop-types';

import {feedbackType} from 'propTypes/products';
import {Section} from 'components/layouts';
import {QUALITY_CONTROL_STATUS} from 'constants/production';

const ActionBadge = ({status, status_label: statusLabel}) => (
    <span
        className={`ml-2 badge badge-pill badge-${status === QUALITY_CONTROL_STATUS.REJECTED ? 'danger' : 'success'}`}
    >
        {statusLabel}
    </span>
);

ActionBadge.propTypes = {
    status: PropTypes.string.isRequired,
    status_label: PropTypes.string.isRequired,
};

const QualityControlFeedback = ({feedbackList, isLoading}) => {
    if (isLoading) {
        return null;
    }

    return (
        <Section title={gettext('Quality control feedback')}>
            {feedbackList.map(feedback => (
                <div key={feedback.id}>
                    <h5>
                        {feedback.product_status_label}
                        <ActionBadge
                            status={feedback.status}
                            status_label={feedback.status_label}
                        />
                    </h5>
                    <p>{feedback.comment}</p>
                </div>
            ))}
        </Section>
    );
};

QualityControlFeedback.propTypes = {
    feedbackList: PropTypes.arrayOf(feedbackType).isRequired,
    isLoading: PropTypes.bool.isRequired,
};

export default QualityControlFeedback;



// WEBPACK FOOTER //
// ./src/components/QualityControlFeedback.js